import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import StatusCard from './status_card'
import { MediaGallery } from '../features/ui/util/async_components'
import Poll from './poll'
import AudioPlayer from './audio_player'

// We use the component (and not the container) since we do not want
// to use the progress bar to show download progress
import Bundle from '../features/ui/util/bundle'
import { CX } from '../constants'

class StatusMedia extends ImmutablePureComponent {

  // Avoid checking props that are functions (and whose equality will always
  // evaluate to false. See react-immutable-pure-component for usage.
  updateOnProps = [
    'status',
    'isChild',
    'isComment',
    'defaultWidth',
    'visible',
    'width',
    'isComposeModalOpen',
    'isNotification',
  ]

  renderLoadingMedia() {
    return <div className={_s.backgroundColorPanel} style={{ height: '110px' }} />
  }

  render() {
    const {
      status,
      isChild,
      isComment,
      onOpenMedia,
      onOpenVideo,
      width,
      onToggleVisibility,
      visible,
      defaultWidth,
      isComposeModalOpen,
      isStatusCard,
      isNotification,
    } = this.props

    if (!status) return null

    let media = []
    let status_media = status.get('media_attachments') || []
    let spoiler_text = status.get('spoiler_text') || ''
    const statusId = status.get('id')

    if (status_media.size > 0) {
      const mediaAttachments = status.get('media_attachments')
      const audioAttachments = mediaAttachments.filter(attachment => attachment.get('type') === 'audio')
      const nonAudioAttachments = mediaAttachments.filter(attachment => attachment.get('type') !== 'audio')

      // Render audio attachments
      audioAttachments.forEach((attachment, index) => {
        media.push(
          <AudioPlayer
            key={`status-${statusId}-audio-${index}`}
            src={attachment.get('url')}
            title={attachment.get('description')}
          />
        )
      })

      // Render non-audio attachments
      if (nonAudioAttachments.size > 0) {
        media.push(
          <Bundle
            key={`status-${statusId}-gallery`}
            fetchComponent={MediaGallery}
            loading={this.renderLoadingMedia}
          >
            {Component => (
              <Component
                isComment={isComment}
                reduced={isChild}
                isNotification={isNotification}
                media={nonAudioAttachments}
                sensitive={status.get('sensitive')}
                onOpenMedia={onOpenMedia}
                defaultWidth={defaultWidth}
                visible={visible}
                onToggleVisibility={onToggleVisibility}
              />
            )}
          </Bundle>
        )
      }
    } else {
      const cardClasses = CX({
        d: 1,
        px10: !isComment,
      })
      if (spoiler_text.length === 0 && status.get('card')) {
        media.push(
          <div key={`status-${statusId}-card`} className={cardClasses}>
            <StatusCard
              card={status.get('card')}
              onOpenMedia={onOpenMedia}
              defaultWidth={defaultWidth}
              isImageSmall={isComment || isNotification}
              isVertical={isChild && !isNotification}
              isReduced={isStatusCard || isComposeModalOpen}
            />
          </div>
        )
      }
    }
    
    if (status.get('poll')) {
      media.push(<Poll  key={`status-${statusId}-poll`} pollId={status.get('poll')} />)
    }

    if (!media.length) return null

    if (media.length > 1) {
      // if you have multiple elements space them out
      media = media.map((item, index) =>
        <div
          key={`status-${statusId}-spacer-${index}`}
          className={_s.mt5}
        >{item}</div>
      )
    }

    return <div className={_s.mt5}>{media}</div>
  }

}

StatusMedia.propTypes = {
  status: ImmutablePropTypes.map,
  isChild: PropTypes.bool,
  isNotification: PropTypes.bool,
  isComment: PropTypes.bool,
  onOpenMedia: PropTypes.func,
  onOpenVideo: PropTypes.func,
  width: PropTypes.number,
  onToggleVisibility: PropTypes.func,
  visible: PropTypes.bool,
  defaultWidth: PropTypes.number,
  isComposeModalOpen: PropTypes.bool,
  isStatusCard: PropTypes.bool,
}

export default StatusMedia
